<div id="entity-dashboard" class="page-layout carded fullwidth h-100-p">
  <div fxLayout="row" fxLayoutAlign="start start">
    <div
      *ngIf="hasSubjectMarkers || hasLinkedSubjectMarkers"
      class="banner markers"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <span *ngIf="hasSubjectMarkers && hasLinkedSubjectMarkers"
        >{{ subjectTypeName }} and Linked Subjects have Markers</span
      >
      <span *ngIf="hasSubjectMarkers && !hasLinkedSubjectMarkers"
        >{{ subjectTypeName }} has Markers</span
      >
      <span *ngIf="!hasSubjectMarkers && hasLinkedSubjectMarkers"
        >Linked Subjects have Markers</span
      >
    </div>
    <div *ngIf="_data?.entity && rejected" class="banner rejected">
      {{ subjectTypeName }} is Rejected
    </div>
    <div *ngIf="_data?.entity && accepted" class="banner accepted">
      {{ subjectTypeName }} is Accepted
    </div>
    <div *ngIf="_data?.entity && pending" class="banner pending">
      {{ subjectTypeName }} is Pending
    </div>
    <div *ngIf="_data?.entity?.restricted" class="banner restricted">
      {{ subjectTypeName }} is Restricted {{ userListString }}
    </div>
    <div *ngIf="_data?.entity?.archived" class="banner archived">
      {{ subjectTypeName }} is Archived
    </div>
    <div
      *ngIf="showCasePrepUI && _data?.entity?.hasCasePreparationFile"
      class="banner case-prep"
    >
      {{ subjectTypeName }} has a Case Preparation File
    </div>
    <div
      *ngIf="deadlineText && deadlineText.length > 1"
      class="banner deadline"
    >
      {{ deadlineText }}
    </div>
  </div>

  <!-- TOP BACKGROUND -->
  <div
    fxFill
    style="background-color: #fafafa; z-index: 1; position: absolute"
  ></div>
  <div
    *ngIf="_data?.subjectType"
    class="top-bg"
    [ngStyle]="{
      'background-color': _data?.subjectType?.color,
      'margin-top':
        (_data?.entity?.archived ||
        _data?.entity?.restricted ||
        hasSubjectMarkers ||
        hasLinkedSubjectMarkers ||
        reviewStatus > 1
          ? 40
          : 0) + 'px'
    }"
  ></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center" fxFlex>
    <!-- HEADER -->
    <div
      class="header"
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayout.gt-xs="row"
      fxLayoutAlign.gt-xs="space-between center"
    >
      <!-- APP TITLE -->
      <div
        *ngIf="_data?.subjectType"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <button
          *ngIf="previousIds.length > 1"
          class="mr-0 mr-sm-16"
          mat-icon-button
          (click)="goBack()"
          aria-label="Back"
          matTooltip="Back"
        >
          <mat-icon text-contrast [backgroundColor]="_data?.subjectType?.color"
            >arrow_back</mat-icon
          >
        </button>

        <div
          fxLayout="column"
          fxLayoutAlign="start start"
          text-contrast
          [backgroundColor]="_data?.subjectType?.color"
          *fuseIfOnDom
        >
          <div class="h2" id="txtSubjectNameSummary">
            {{ subjectTypeName }}{{ _data?.entity ? ': ' : ''
            }}{{ _data?.entity?.summary }}
          </div>
          <div class="subtitle secondary-text mt-4">
            <span
              id="txtSubjectName"
              text-contrast
              [backgroundColor]="_data?.subjectType?.color"
              >{{ subjectTypeName }} Details</span
            >
          </div>
          <div
            *ngIf="hasSubjectMarkers || hasLinkedSubjectMarkers"
            fxLayout="row"
            fxLayoutAlign="start start"
          >
            <span
              id="markersLabel"
              text-contrast
              [backgroundColor]="_data?.subjectType?.color"
              class="mt-4 mr-12"
              >Markers:</span
            >
            <div *ngIf="hasSubjectMarkers" mat-icon-button class="mat-accent">
              <mat-icon
                class="material-icons marker-icon"
                *ngFor="
                  let subjectMarker of _data?.entity?.subjectMarkers;
                  trackBy: trackById
                "
                [style.color]="subjectMarker.marker?.color"
                [matTooltip]="
                  _data?.entity.summary + ': ' + subjectMarker.marker?.name
                "
                >room</mat-icon
              >
            </div>
            <mat-divider
              *ngIf="hasSubjectMarkers && hasLinkedSubjectMarkers"
              class="style-fix"
              style="height: 24px; margin: 0px 8px 0px 8px"
              [vertical]="true"
            ></mat-divider>
            <div *ngIf="hasLinkedSubjectMarkers">
              <mat-icon
                class="material-icons marker-icon"
                *ngFor="
                  let subjectMarker of _data?.entity?.linkedSubjectMarkers
                "
                [style.color]="subjectMarker.marker?.color"
                [matTooltip]="
                  subjectMarker.subject?.summary +
                  ': ' +
                  subjectMarker.marker?.name
                "
                >room
              </mat-icon>
            </div>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->

      <!-- TOOLBAR -->
      <div
        class="toolbar"
        fxLayout="row"
        fxLayoutAlign="start center"
        *ngIf="_data?.entity"
        text-contrast
        [backgroundColor]="_data?.subjectType?.color"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <!-- NgContainer for non-archived Subject buttons -->
          <ng-container *ngIf="!_data?.entity?.archived">
            <button
              *ngIf="layout?.locked"
              color="secondary"
              mat-button
              id="unlock"
              (click)="editDashboard()"
              aria-label="Edit Layout"
              matTooltip="Edit Layout"
            >
              <mat-icon
                text-contrast
                [backgroundColor]="_data?.subjectType?.color"
                >lock_open</mat-icon
              >
              <span>Unlock</span>
            </button>

            <button
              *ngIf="!layout?.locked"
              color="secondary"
              mat-button
              id="lock"
              (click)="saveDashboard()"
              aria-label="Save Layout Changes"
              matTooltip="Save Layout Changes"
            >
              <mat-icon
                text-contrast
                [backgroundColor]="_data?.subjectType?.color"
                >lock</mat-icon
              >
              <span>Lock</span>
            </button>

            <mat-divider class="style-fix" [vertical]="true"></mat-divider>

            <button
              color="secondary"
              mat-button
              id="add_widget"
              [matMenuTriggerFor]="addWidgetMenu"
              attr.aria-label="Add Widget To {{ subjectTypeName }}"
              matTooltip="Add Widget To Dashboard"
            >
              <mat-icon
                text-contrast
                [backgroundColor]="_data?.subjectType?.color"
                >add</mat-icon
              >
              <span aria-label="Add Widget">Add</span>
            </button>

            <mat-menu #addWidgetMenu="matMenu">
              <button
                *ngFor="let item of availableWidgets"
                mat-menu-item
                (click)="layout.addWidget(item)"
              >
                {{ item?.name }}
              </button>
              <mat-divider></mat-divider>
              <button
                *ngFor="let item of fixedWidgets"
                mat-menu-item
                (click)="layout.addWidget(item)"
              >
                {{ item?.name }}
              </button>
            </mat-menu>

            <div *ngIf="!userReadOnly && hasSubjectUserEditPrivs">
              <button
                color="secondary"
                mat-button
                id="link_menu_open"
                [matMenuTriggerFor]="addLinkMenu"
                matTooltip="Link Subject"
                aria-label="Link Subject"
              >
                <mat-icon
                  text-contrast
                  [backgroundColor]="_data?.subjectType?.color"
                  >link</mat-icon
                >
                <span>Link</span>
              </button>

              <mat-menu #addLinkMenu="matMenu">
                <button
                  *ngFor="let item of links"
                  mat-menu-item
                  (click)="addLink(item)"
                >
                  {{ item?.name }}
                </button>
              </mat-menu>
            </div>
            <mat-divider class="style-fix" [vertical]="true"></mat-divider>
          </ng-container>

          <button
            color="secondary"
            mat-button
            id="actions_menu_open"
            [matMenuTriggerFor]="actionsMenu"
            attr.aria-label="Actions Menu {{ subjectTypeName }}"
            matTooltip="Actions Menu"
          >
            <mat-icon
              text-contrast
              [backgroundColor]="_data?.subjectType?.color"
              >flash_on</mat-icon
            >
            <span>Actions</span>
          </button>
          <mat-menu #actionsMenu="matMenu">
            <button
              mat-menu-item
              *ngIf="
                !_data?.entity?.archived &&
                !userReadOnly &&
                isPrimarySubject &&
                _data?.subjectType &&
                hasSubjectUserEditPrivs
              "
              color="secondary"
              id="archive"
              (click)="archive()"
              matTooltip="Archive {{ subjectTypeName }}"
              attr.aria-label="Archive {{ subjectTypeName }}"
            >
              <mat-icon>archive</mat-icon>
              <span>Archive</span>
            </button>

            <!-- && !_data?.entity?.archived -->
            <button
              *ngIf="isAdmin && _data?.entity?.retentionDate"
              mat-menu-item
              color="secondary"
              id="changeRetentionPeriod"
              (click)="changeRetentionPeriod()"
              matTooltip="Change Retention Period"
              attr.aria-label="Change Retention Period"
            >
              <mat-icon>auto_delete</mat-icon>
              Change Retention Period
            </button>
            <button
              mat-menu-item
              *ngIf="!userReadOnly && showCasePrepUI && hasSubjectUserEditPrivs"
              id="case_preparation_menu_open"
              [matMenuTriggerFor]="casePreparationMenu"
              matTooltip="Case Preparation"
              aria-label="Case Preparation"
              [disabled]="casePrepUIDisabled"
            >
              <mat-icon>cloud_upload</mat-icon>
              <span>Case Preparation</span>
            </button>
            <mat-menu #casePreparationMenu="matMenu">
              <button
                *ngIf="!_data?.entity?.hasCasePreparationFile"
                mat-menu-item
                (click)="createCasePreparationFileClicked()"
              >
                Create Case Preparation File
              </button>
              <button
                *ngIf="_data?.entity?.hasCasePreparationFile"
                mat-menu-item
                (click)="openCasePreparationFileClicked()"
              >
                Open Case Preparation File
              </button>
              <button
                *ngIf="_data?.entity?.hasCasePreparationFile"
                mat-menu-item
                (click)="deleteCasePreparationFileClicked()"
              >
                Delete Case Preparation File
              </button>
            </mat-menu>

            <button
              mat-menu-item
              *ngIf="
                !userReadOnly &&
                hasSubjectUserEditPrivs &&
                _data?.subjectType &&
                (canAccept ||
                  canReject ||
                  allowAssessment ||
                  canConvertToSubject)
              "
              color="secondary"
              id="review_menu_open"
              [matMenuTriggerFor]="reviewMenu"
              attr.aria-label="Review {{ subjectTypeName }}"
              matTooltip="Review {{ subjectTypeName }}"
            >
              <mat-icon>post_add</mat-icon>
              Review
            </button>

            <mat-menu #reviewMenu="matMenu">
              <button
                mat-menu-item
                *ngIf="canAccept"
                id="accept"
                (click)="accept()"
                matTooltip="Accept {{ subjectTypeName }}"
              >
                Accept
              </button>
              <button
                mat-menu-item
                *ngIf="canReject"
                id="reject"
                (click)="reject()"
                matTooltip="Reject {{ subjectTypeName }}"
              >
                Reject
              </button>
              <button
                mat-menu-item
                *ngIf="canReview"
                id="review"
                (click)="review()"
                matTooltip="Review {{ subjectTypeName }}"
              >
                Review
              </button>
              <mat-divider
                *ngIf="allowAssessment && (canAccept || canReject)"
              ></mat-divider>
              <button
                *ngFor="let assessment of incompleteAssessments"
                mat-menu-item
                (click)="editAssessment(assessment)"
              >
                {{ assessment.assessmentTemplate.name
                }}<span class="in-progress"> - In Progress</span>
              </button>
              <mat-divider
                *ngIf="
                  allowAssessment &&
                  incompleteAssessments &&
                  incompleteAssessments.length > 0
                "
              ></mat-divider>
              <button
                mat-menu-item
                *ngIf="allowAssessment"
                id="add_assessment"
                (click)="addAssessment()"
                matTooltip="Add Assessment"
              >
                Add Assessment
              </button>
              <mat-divider
                *ngIf="
                  canConvertToSubject &&
                  (allowAssessment || canAccept || canReject)
                "
              ></mat-divider>
              <button
                mat-menu-item
                *ngIf="canConvertToSubject"
                id="convertToSubject"
                (click)="convertToSubject()"
                matTooltip="Convert to {{ _data?.subjectType?.name }}"
              >
                {{ 'Convert to ' + _data?.subjectType?.name }}
              </button>
            </mat-menu>

            <button
              mat-menu-item
              *ngIf="
                !userReadOnly &&
                isPrimarySubject &&
                _data?.subjectType &&
                showSecurity &&
                hasSubjectUserEditPrivs
              "
              color="secondary"
              id="lock"
              #securityButton
              (click)="
                securityButton._elementRef.nativeElement.blur(); applySecurity()
              "
              matTooltip="Change {{ subjectTypeName }} Permissions"
              attr.aria-label="Change {{ subjectTypeName }} Permissions"
            >
              <mat-icon>how_to_reg</mat-icon>
              <span>Security</span>
            </button>

            <button
            *ngIf="
                !userReadOnly &&
                isPrimarySubject &&
                _data?.subjectType &&
                (_data?.entity.subjectLinks.length>0) &&
                showTaskNotifications
              "
              color="secondary"
              id="taskNotifications"
              (click)="changeTaskNotificationSubjects()"
              mat-menu-item
              matTooltip="Change Recipients of Task Notifications"
              attr.aria-label="Change Recipients of Task Notifications"
            >
              <mat-icon>assignment_ind</mat-icon><span>Task Notifications</span>
            </button>

            <mat-divider></mat-divider>

            <button
              mat-menu-item
              *ngIf="
                _data?.entity?.archived &&
                !userReadOnly &&
                isAdmin &&
                isPrimarySubject &&
                _data?.subjectType &&
                hasSubjectUserEditPrivs
              "
              color="secondary"
              id="unarchive"
              (click)="unarchive()"
              matTooltip="Unarchive {{ subjectTypeName }}"
              attr.aria-label="Unarchive {{ subjectTypeName }}"
            >
              <mat-icon>unarchive</mat-icon>
              <span>Unarchive</span>
            </button>

            <mat-divider></mat-divider>

            <button
              *ngIf="userCanExportData"
              mat-menu-item
              color="secondary"
              id="print"
              #printButton
              (click)="printButton._elementRef.nativeElement.blur(); print()"
              matTooltip="Print"
              attr.aria-label="Print"
            >
              <mat-icon>print</mat-icon>
              <span>Print</span>
            </button>

            <app-visualize
              [subject]="_data?.entity"
              [backgroundColor]="_data?.subjectType?.color"
            ></app-visualize>
            <app-show-map
              [subject]="_data?.entity"
              [backgroundColor]="_data?.subjectType?.color"
            ></app-show-map>
          </mat-menu>
        </div>
      </div>
      <!-- / TOOLBAR -->
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content-card mat-white-bg">
      <!-- <div style="background-color:red;color:white;min-height:100px;width:100%;">Case is Archived</div> -->
      <layout-builder
        class="h-100-p"
        #layout
        [showToolbar]="false"
        [contentBackgroundColor]="'transparent'"
        (onLayoutChanged)="layoutChanged($event)"
        (onDebouncedLayoutChanged)="saveChanges($event)"
        (onAddWidget)="addWidget($event)"
        (onRemoveWidget)="removeWidget($event)"
      ></layout-builder>
    </div>
    <!-- / CONTENT -->
  </div>
  <!-- / CENTER -->
</div>
